module.exports = __webpack_public_path__ + "img/auth-side-cover.91fa6518.jpg";